import React from 'react';
import PropTypes from 'prop-types';
import useDateTime from '@hooks/use-datetime';
import { parse } from 'date-fns';
import { periodHandler } from '@utilities/helpers/common';

const Period = ({ period, children }) => {
  const { format: formatDate } = useDateTime();
  return (
    <div>
      {periodHandler({ period, formatDate, parse })}
      {children}
    </div>
  );
};

Period.propTypes = {
  period: PropTypes.string.isRequired,
  // currency: PropTypes.string,
  // zeroValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Period.defaultProps = {
  // zeroValue: 0,
  // currency: 'DKK',
};

export default Period;
